import { useEffect } from 'react';
import TopBar from './TopBar';
import Navbar from './Navbar';
import Footer from './Footer';
import BackToTop from './BackToTop';
import './layout.css';  // Import the CSS file

const Layout = ({ children }) => {
  return (
    <div className="wrapper">
      <TopBar />
      <Navbar />
      <main>{children}</main>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Layout;